export function generatePassword(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);
    let password = '';
    for (let i = 0; i < randomValues.length; i++) {
        const charIndex = randomValues[i] % chars.length;
        password += chars[charIndex];
    }

    return password;
}
